import { api } from "../../api";

const GatewayActions = {
    async getEncodings({ commit }) {
        const encodings = await api.gateways.getEncodings();
        return commit('setEncodings', encodings);
    },
    async getMetadatas({ commit }) {
        const metadatas = await api.gateways.getMetadatas();
        return commit('setMetadatas', metadatas);
    },
    async getGatewayById({ commit }, gatewayId) {
        const gateway = await api.gateways.getById(gatewayId);
        return commit('setActiveGateway', gateway);
    },
    async getGateways({ commit }) {
        const gateways = await api.gateways.getList();
        return commit('setGateways', gateways);
    },
    async getGatewayBindings({ commit }, gatewayId) {
        const bindings = await api.bindings.get(gatewayId);
        return commit('setGatewayBindings', bindings);
    },
    async removeGateway({ commit }, gatewayId) {
        try {
            await api.gateways.remove(gatewayId);
            commit('onSuccess')
        } catch (err) {
            commit('onFailure');
        }
    },
    async saveGateway({ state }) {
        try {
            const gateway = state.activeGateway;
            const isUpdate = !!gateway.id;
            const fetchMethod = gateway.configuration.fetchMethod;
            const encodingId = gateway.configuration.globalConfiguration.encodingId;

            const configuration = {
                __fetch_method__: fetchMethod,
            };

            if (fetchMethod === 'URL') {
                configuration.listing_url = gateway.configuration.urlConfiguration.listingURL;
                configuration.media_url = gateway.configuration.urlConfiguration.mediaURL;
            }

            if (fetchMethod === 'EXTERNAL_FTP') {
                configuration.url = gateway.configuration.externalFTPConfiguration.url;
                configuration.login = gateway.configuration.externalFTPConfiguration.login;
                configuration.secret = gateway.configuration.externalFTPConfiguration.secret;
                configuration.do_recursive_file_search = gateway.configuration.externalFTPConfiguration.doRecursiveFileSearch;
            }

            if (fetchMethod === 'PROXY') {
                configuration.proxy_code = gateway.configuration.proxyCode;
            }

            const zipName = () => {
                if (gateway.configuration.fileConfiguration.isZip === false) {
                    return null;
                }

                const { zipName: z } = gateway.configuration.fileConfiguration;
                return (z && z.endsWith('.zip')) ? z : z + '.zip';
            }

            const mediaFetchMethod = gateway.configuration.mediaConfiguration.fetchMethod

            const dto = {
                id: gateway.id,
                name: gateway.name,
                comment: gateway.comment,
                fetch_method: fetchMethod,
                is_complex_gateway: gateway.configuration.isComplexGatewayConfig,
                cron_expression: gateway.configuration.cronExpression ? gateway.configuration.cronExpression : 'EVERY_12HOURS',
                metadata_ids: [],
                gateway_config_id: gateway.configuration.id,
                global_configuration: {
                    id: gateway.configuration.globalConfiguration.id,
                    encoding_id: (encodingId > 0) ? encodingId : null,
                    max_media_download_count: gateway.configuration.globalConfiguration.maxMediaDownloadCount,
                    download_batch_length: gateway.configuration.globalConfiguration.downloadBatchLength,
                },
                file_configuration: {
                    id: gateway.configuration.fileConfiguration.id,
                    ownership: gateway.configuration.fileConfiguration.ownership,
                    is_zip: gateway.configuration.fileConfiguration.isZip,
                    zip_name: zipName(),
                    file_name: gateway.configuration.fileConfiguration.fileName,
                    file_extension: gateway.configuration.fileConfiguration.fileExtension,
                    file_type: gateway.configuration.fileConfiguration.fileType,
                    file_separator: gateway.configuration.fileConfiguration.fileSeparator
                },
                media_configuration: {
                    id: gateway.configuration.mediaConfiguration.id,
                    fetch_method: mediaFetchMethod,
                    folder: (['URL', 'URL_BASE64'].includes(mediaFetchMethod))
                        ? null
                        : gateway.configuration.mediaConfiguration.folder,
                    data_field: (mediaFetchMethod === 'URL_BASE64') 
                        ? gateway.configuration.mediaConfiguration.dataField
                        : null,
                    is_iterative: gateway.configuration.mediaConfiguration.isIterative,
                    download_delay: gateway.configuration.mediaConfiguration.downloadDelay,
                    ignore_existing_media_file_name: gateway.configuration.mediaConfiguration.ignoreExistingMediaFileName,
                },
                configuration,
            };

            const stringifiedDTO = JSON.stringify(dto);
            for (const metadata of state.metadatas.filter(m => m.id > 0)) {
                if (stringifiedDTO.match(new RegExp(metadata.code, 'g'))) {
                    if (dto.metadata_ids.includes(metadata.id) === false) {
                        dto.metadata_ids.push(metadata.id);
                    }
                }
            }

            isUpdate
                ? await api.gateways.update(gateway.id, dto)
                : await api.gateways.create(dto);
            
            return true;
        } catch (error) {
            console.log(error);
            return false;
        }
    }
}

export default GatewayActions;
